export class GeneratePdfItineraryByText {
  public ItineraryGenerated: string;
}
